import LexicalHtmlEditor from "@/components/admin/LexicalHtmlEditor";

type Props = {
  value: string;
  onChange: (nextHtml: string) => void;
  className?: string;
};

export default function LessonArticleEditor({ value, onChange, className }: Props) {
  return (
    <LexicalHtmlEditor
      value={value}
      onChange={onChange}
      className={className}
      namespace="lesson-lexical"
      placeholder="Write the lesson…"
      minHeightClassName="min-h-[280px]"
    />
  );
}


